import React, { useEffect, useContext, useState } from 'react';
import axios from 'axios';

import { CountryContext } from 'context/CountryContext';
import { ProductTabsContext } from 'context/ProductTabsContext';

import Loader from 'components/Loader';
import { tecDocUrl, PROVIDER_ID, basicAuth } from 'utils/constantsHelper';
import { langCode } from 'utils/currentLanguage';

export const withArticleLinkedManufactures = (WrappedComponent) => {
  return (props) => {
    const { productId } = props;
    const { currentCountry } = useContext(CountryContext);
    const { linkedVehiclesTab, setLinkedVehiclesTab } = useContext(
      ProductTabsContext
    );
    const [isLoading, setIsLoading] = useState(!linkedVehiclesTab);

    const getData = () => {
      axios
        .post(
          tecDocUrl,
          {
            getArticleLinkedAllLinkingTargetManufacturer: {
              articleCountry: currentCountry,
              lang: langCode,
              articleId: productId,
              linkingTargetType: 'PO',
              provider: PROVIDER_ID,
            },
          },
          { headers: basicAuth }
        )
        .then((response) => {
          if (response.status === 200) {
            setIsLoading(false);
            setLinkedVehiclesTab(response.data.data);
          }

          // Remove min-height style to prevent jumping tabs on click.
          document.getElementById('product-tabs') &&
            document.getElementById('product-tabs').removeAttribute('style');
        })
        .catch(() => {
          setIsLoading(false);
        });
    };

    useEffect(() => {
      if (!linkedVehiclesTab) {
        getData();
      }
    }, []);

    if (isLoading) {
      return <Loader />;
    }

    return <WrappedComponent {...props} />;
  };
};



// WEBPACK FOOTER //
// ./src/containers/withArticleLinkedManufactures/withArticleLinkedManufactures.js